import React from 'react'
import { Modal, Row } from "antd";


const CustomModal = ({
    title,
    className,
    open,
    cancelModal,
    width,
    centered,
    Children,
    destroyOnClose,
    style
}) => {
    return (


        <Modal
            style={style}
            title={title}
            wrapClassName={`custom-modal ${className}`}
            open={open}
            closeIcon={true}
            width={width ? width : 520}
            onCancel={cancelModal}
            cancelButtonProps={false}
            footer={null}
            centered={centered}
            closable={true}
            destroyOnClose={destroyOnClose}
        >

            <Row className='w-full'>

                {Children}

            </Row>


        </Modal>



    )
}

export default CustomModal